/**
 * @fileoverview The evidence behind a drafted entry (MOR-2335): each
 * activity record with its kind, time and source. Sources the practitioner
 * can no longer reach are labelled, and a restricted source never shows
 * its content.
 */

import { Link2Off } from "lucide-react";
import { cn } from "@/utils/misc";
import {
  KIND_LABEL,
  SOURCE_LABEL,
  SOURCE_STATE_LABEL,
  type DraftEvidence,
} from "./draftSuggestions.helpers";

export function DraftEvidenceList({
  evidence,
  className,
}: {
  evidence: DraftEvidence[];
  className?: string;
}) {
  if (evidence.length === 0) {
    return (
      <p className={cn("text-xs text-muted-foreground", className)}>
        No activity is linked to this entry.
      </p>
    );
  }
  return (
    <ul className={cn("flex flex-col gap-1.5", className)}>
      {evidence.map((item) => {
        const stateLabel = SOURCE_STATE_LABEL[item.sourceState];
        return (
          <li
            key={item.activityId}
            className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 text-xs"
          >
            <span className="font-medium text-foreground">
              {KIND_LABEL[item.kind]}
            </span>
            <span className="tabular-nums text-muted-foreground">
              {item.localTime}
            </span>
            <span className="text-muted-foreground">{item.summary}</span>
            {item.eventCount !== undefined && item.eventCount > 1 && (
              <span className="text-muted-foreground">
                · {item.eventCount} saves
              </span>
            )}
            <span className="text-muted-foreground/80">
              {SOURCE_LABEL[item.source]}
              {item.alsoSeenIn.length > 0 &&
                ` (also in ${item.alsoSeenIn.map((s) => SOURCE_LABEL[s]).join(", ")})`}
            </span>
            {stateLabel ? (
              <span
                className="inline-flex items-center gap-1 text-amber-700 dark:text-amber-400"
                role="status"
              >
                <Link2Off className="size-3" aria-hidden />
                {stateLabel}
              </span>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
